import { render, staticRenderFns } from "./EcommerceComponent.vue?vue&type=template&id=46ba0946&scoped=true&"
import script from "./EcommerceComponent.vue?vue&type=script&lang=js&"
export * from "./EcommerceComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ba0946",
  null
  
)

export default component.exports